import { Button, Form, Image, Input, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useLocation } from "wouter";
import { useEffect, useState } from "react";
import { DealerResetPwd } from "../../../redux/actions/authActions";
import Alertify from "../../../services/alertify";
const { Title } = Typography;
const DealerResetPassword = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [cpasswordVisible, setCPasswordVisible] = useState(false);
  const dispatch = useDispatch();
  const [, setLocation] = useLocation();
  const [token, setToken] = useState(null);
  const [email, setEmail] = useState(null);
  //   get token and email from the URL
  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    setToken(params.get("token"));
    setEmail(params.get("email"));
  });
  const handleSubmit = (values) => {
    const data = {
      email: email,
      token: token,
      password: values.password,
      password_confirmation: values.password_confirmation,
    };
    // console.log(data);

    dispatch(DealerResetPwd(data))
      .then((response) => {
        // console.log(response);
        if (response.meta.requestStatus === "fulfilled") {
          setLocation("/login/dealer");
        }
      })
      .catch((error) => {
        Alertify.error("Pasword reset: " + error.message);
      });
  };
  return (
    <div className="grid my-8 place-items-center max-sm:p-4">
      <Form
        layout="vertical"
        className="shadow-2xl p-10 sm:w-1/3 rounded-lg w-full"
        size={"large"}
        onFinish={handleSubmit}
      >
        <Image width={100} src="/assets/alp.svg" preview={false} />
        <Title level={2}>Reset Password</Title>
        <Form.Item label="Password" name="password">
          <Input.Password
            placeholder="Enter Password"
            visibilityToggle={{
              visible: passwordVisible,
              onVisibleChange: setPasswordVisible,
            }}
          />
        </Form.Item>
        <Form.Item
          label="Confirm Password"
          name="password_confirmation"
          dependencies={["password"]}
          rules={[
            {
              required: true,
              message: "Please confirm your password",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match!"));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Confirm Password"
            visibilityToggle={{
              visible: cpasswordVisible,
              onVisibleChange: setCPasswordVisible,
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button className="w-full" type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default DealerResetPassword;
